import { ColorInfo } from 'editor/src/store/hostSettings/types';

// `name` is passed in so a caller can show it translated. A print partner's thread may have no
// Madeira reference; the label leaves it out only with partner settings (hasPrintPartnerSettings).
const getThreadColorLabel = ({ madeira_ref }: ColorInfo[string], name: string, partner: boolean): string =>
  partner ? [madeira_ref, name].filter(Boolean).join(' ') : `${madeira_ref} ${name}`;

export default getThreadColorLabel;
